﻿import { ErrorTemplateBuilder } from "./error-template-builder";
import SyncerManager from "./sync-manager";
import EnvironmentVariables from "../EnvironmentVariables";
import { CxAppSettingsService } from "../common/services/cx-app-settings-service";
import { EntitySyncManager } from "./entity-sync-manager";
import { SignalrHubManager } from "../common/services/signalr-hub-manager";
import { SignalrServiceClass } from "../common/services/signalr-service";
import { rootStoreConstant } from "../common/constant/root-action-mutation-getter";
import { initHttpService } from "../common/helper/http-service/http-service";
import { authService } from "../common/services/auth-service";
import contactService from "../common/services/contact-service";
import { appInsightTrackEvent, appInsightObject } from "../root/AppInsights";
import store from "../root/store/store";

export class DataBootstrapper {
  public static async init() {
    await SyncerManager.Instance.init();
  }

  public static async loadBootData() {
    try {
      EnvironmentVariables.SetApimSubscriptionKeyVariable();
      await this.loadLoggedInUserInfo();
      this.loadDataInBackground();
    } catch (e) {
      throw new Error(
        ErrorTemplateBuilder.getCatchText("PresetLoader.Init", e),
      );
    }
  }

  private static async loadDataInBackground() {
    await Promise.all([
      CxAppSettingsService.load(),
      EntitySyncManager.fillEnums(),
      EntitySyncManager.fillDummyRecords(),
    ]);
    await DataBootstrapper.init();
    await SignalrHubManager.Instance.Init();
    await SignalrServiceClass.joinSignalRGroups();
  }

  private static async loadLoggedInUserInfo() {
    store.dispatch(rootStoreConstant.action.setAccountNotExistStatus, {
      isAccountNotExist: false,
    });
    if (authService.isAuthenticated()) {
      initHttpService(store, undefined);
      try {
        // Global portal tag rows must exist before setContactTagPermissions (SET_CONTACT);
        // otherwise tag getters stay false and permission-gated routes redirect on refresh.
        await Promise.all([
          CxAppSettingsService.load(),
          EntitySyncManager.fillEnums(),
          EntitySyncManager.fillDummyRecords(),
        ]);
        await EntitySyncManager.fillContactTags();

        let loggedInUser = await contactService.fetchContactFromApi();
        if (!loggedInUser) {
          loggedInUser = contactService.fetchContactFromLocalStorage();
        }
        let isContactLoaded = contactService.AddContactToStore(loggedInUser);
        if (!isContactLoaded) {
          console.log("Error in loading contact information");
          //AppInsight Event
          let appInsightObject: appInsightObject = {
            name: "Contact Email Address",
            value: authService.GetAuthenticatedUserEmail(),
          };
          appInsightTrackEvent(
            [appInsightObject],
            "CRM-ErrorLoadingContactInfo",
          );
        }
      } catch (e: any) {
        console.log(e);
        if (e.response.status == 500) {
          //AppInsight Event
          let appInsightObject: appInsightObject = {
            name: "Contact Email Address",
            value: authService.GetAuthenticatedUserEmail(),
          };
          appInsightTrackEvent([appInsightObject], "CRM-ContactEmailNotFound");
          store.dispatch(rootStoreConstant.action.setAccountNotExistStatus, {
            isAccountNotExist: true,
          });
        }
      }
    }
  }
}
